import React from 'react';
import { TopicIndex } from '../layout/TopicIndex';
import { solutionDepth } from '../../data/applicationPages';
import type { SolutionId } from '../../data/solutionCatalog';

/** Optional deeper reading for a solution, after the shared structure. */
export function SolutionDepthSection({
  id
}: {
  id: SolutionId;
}) {
  const depth = solutionDepth[id];
  if (!depth) return null;
  return <TopicIndex topics={depth.topics} indexLabel="In this section" heading={depth.heading} headingNote={depth.note} data-id="element-2668" data-mp="15no8lafpd5as" />;
}